import { Button, FormControl, Grid, TextField } from "@material-ui/core";
import moment from "moment";
import React, { Component } from "react";
import { fetchShiprtbt } from "../../api/portal";
import MapVoyage from "./mapvoyage";
import { withRouter } from "react-router-dom";

export class Voyage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      openMap: false,
      center: [parseFloat(118.15), parseFloat(-3.1)],
      zoom: parseFloat(4),
      source: "GPS",
      lonLat: [],
      loading: false
    };
  }

  componentDidMount() {
    let startdate = new Date(
      moment(this.props.start).format("YYYY-MM-DDTHH:mm:ss")
    );
    // startdate.setDate(startdate.getDate() - 1);

    let endDate = new Date(
      moment(this.props.end).format("YYYY-MM-DDTHH:mm:ss")
    );

    this.setState({
      startDate: moment(startdate).format("YYYY-MM-DDTHH:mm"),
      endDate: moment(endDate).format("YYYY-MM-DDTHH:mm")
    });
  }

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleClose = () => {
    this.setState({ openMap: false });
  };

  handleShow = () => {
    this.setState({ openMap: true, loading: true });
    let lonlat = [];
    let start = new Date(this.state.startDate);
    start.setHours(0, 0, 0, 0);
    let end = new Date(this.state.endDate);
    end.setHours(24, 0, 0, 0);

    let timeStart = moment(start).format("YYYY-MM-DD HH:mm:ss");
    let timeEnd = moment(end).format("YYYY-MM-DD HH:mm:ss");

    fetchShiprtbt(this.props.shipId, timeStart, timeEnd, this.state.source)
      .then(response => {
        let dataxx = [];
        let i = 0;

        response.data.results.map(e => {
          dataxx.push({
            keynya: i++,
            date_created: e.date_created,
            lat: e.lat,
            lon: e.lon,
            speed: e.speed
          });
        });
        this.setState({ dataship: dataxx });
        response.data.results.map(ee => {
          lonlat.push([
            parseFloat(ee.lon).toFixed(4),
            parseFloat(ee.lat).toFixed(4),
            ee.date_created,
            ee.speed
          ]);
        });
        this.setState({ lonLat: lonlat, loading: false });
        // this.props.pushShipTrack(lonlat.toString());
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  };

  render() {
    return (
      <Grid
        container
        justifyContent="space-around"
        direction="row"
        alignItems="center"
        style={{ padding: 10 }}
      >
        <Grid item xs={12} sm={3}>
          <FormControl
            variant="outlined"
            size="small"
            fullWidth={true}
            style={{ paddingBottom: 6 }}
          >
            <TextField
              size="small"
              id="date"
              label="Start Date"
              type="datetime-local"
              variant="outlined"
              value={this.state.startDate}
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                value: this.state.startDate,
                onChange: this.handleStartDate
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl
            variant="outlined"
            size="small"
            fullWidth={true}
            style={{ paddingBottom: 6 }}
          >
            <TextField
              size="small"
              variant="outlined"
              id="date"
              label="End Date"
              type="datetime-local"
              value={this.state.endDate}
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                value: this.state.endDate,
                onChange: this.handleEndDate
              }}
            />
          </FormControl>
        </Grid>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          direction="row"
          xs={12}
          sm={3}
        >
          <Grid item xs={12} sm={this.state.openMap ? 6 : 12}>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth={true}
              style={{ paddingBottom: 6 }}
            >
              <Button
                variant="outlined"
                color="primary"
                onClick={this.handleShow}
              >
                Show
              </Button>
            </FormControl>
          </Grid>
          {this.state.openMap ? (
            <Grid item xs={12} sm={6}>
              <FormControl
                variant="outlined"
                size="small"
                fullWidth={true}
                style={{ paddingBottom: 6 }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.handleClose}
                >
                  Close Map
                </Button>
              </FormControl>
            </Grid>
          ) : null}
        </Grid>
        {this.state.openMap ? (
          !this.state.loading ? (
            <Grid xs={12}>
              <MapVoyage
                voyageName={this.props.voyageName}
                data={this.state.lonLat}
              />
            </Grid>
          ) : (
            <Grid container alignItems="center" justifyContent="center">
              <Grid item xs={12}>
                <p>Loading...</p>
              </Grid>
            </Grid>
          )
        ) : null}
      </Grid>
    );
  }
}

export default withRouter(Voyage);
